"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetGrid = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal"); // tkay added confirmation modal to confirm provider delete
const upload_modal_1 = require("client/components/upload-modal");
const store_1 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const react_grid_layout_1 = require("react-grid-layout");
const alert_widget_1 = require("./components/alert-widget");
const backorder_widget_1 = require("./components/backorder-widget");
const claim_widget_1 = require("./components/claim-widget");
const dispense_widget_1 = require("./components/dispense-widget");
const financial_widget_1 = require("./components/financial-widget");
const intent_widget_1 = require("./components/intent-widget");
const pad_widget_1 = require("./components/pad-widget");
const payment_widget_1 = require("./components/payment-widget");
const pharmacy_widget_1 = require("./components/pharmacy-widget");
const provider_widget_1 = require("./components/provider-widget");
const ResponsiveReactGridLayout = react_grid_layout_1.WidthProvider(react_grid_layout_1.Responsive);
const button_1 = require("client/components/material/button");
const router_1 = require("client/components/router");
const moment = require("moment");
const store_2 = require("../../store");
const alert_modal_1 = require("./components/alert-modal");
require("./widget-grid.less");
const defaultLayouts = {
    lg: [
        {
            w: 6,
            h: 17,
            x: 0,
            y: 0,
            i: "1",
            minW: 1,
            minH: 1,
            moved: false,
            static: false
        },
        {
            w: 6,
            h: 8,
            x: 6,
            y: 17,
            i: "2",
            minW: 1,
            minH: 1,
            moved: false,
            static: false
        },
        {
            w: 6,
            h: 8,
            x: 6,
            y: 9,
            i: "3",
            minW: 1,
            minH: 1,
            moved: false,
            static: false
        },
        {
            w: 6,
            h: 9,
            x: 6,
            y: 0,
            i: "4",
            minW: 1,
            minH: 1,
            moved: false,
            static: false
        },
        {
            w: 6,
            h: 5,
            x: 0,
            y: 25,
            i: "5",
            minW: 1,
            minH: 1,
            moved: false,
            static: false
        },
        {
            w: 6,
            h: 8,
            x: 0,
            y: 17,
            i: "6",
            minW: 1,
            minH: 1,
            moved: false,
            static: false
        }
    ],
    sm: [
        {
            w: 3,
            h: 17,
            x: 0,
            y: 0,
            i: "1",
            minW: 1,
            minH: 1,
            moved: false,
            static: false
        },
        {
            w: 3,
            h: 5,
            x: 3,
            y: 0,
            i: "2",
            minW: 1,
            minH: 1,
            moved: false,
            static: false
        },
        {
            w: 3,
            h: 5,
            x: 3,
            y: 12,
            i: "3",
            minW: 1,
            minH: 1,
            moved: false,
            static: false
        },
        {
            w: 3,
            h: 3,
            x: 3,
            y: 9,
            i: "4",
            minW: 1,
            minH: 1,
            moved: false,
            static: false
        },
        {
            w: 3,
            h: 4,
            x: 3,
            y: 5,
            i: "5",
            minW: 1,
            minH: 1,
            moved: false,
            static: false
        },
        {
            w: 6,
            h: 7,
            x: 0,
            y: 17,
            i: "6",
            minW: 1,
            minH: 1,
            moved: false,
            static: false
        }
    ],
    xs: [
        {
            w: 4,
            h: 13,
            x: 0,
            y: 0,
            i: "1",
            minW: 1,
            minH: 1,
            moved: false,
            static: false
        },
        {
            w: 4,
            h: 6,
            x: 0,
            y: 26,
            i: "2",
            minW: 1,
            minH: 1,
            moved: false,
            static: false
        },
        {
            w: 4,
            h: 6,
            x: 0,
            y: 20,
            i: "3",
            minW: 1,
            minH: 1,
            moved: false,
            static: false
        },
        {
            w: 4,
            h: 7,
            x: 0,
            y: 13,
            i: "4",
            minW: 1,
            minH: 1,
            moved: false,
            static: false
        },
        {
            w: 4,
            h: 7,
            x: 0,
            y: 39,
            i: "5",
            minW: 1,
            minH: 1,
            moved: false,
            static: false
        },
        {
            w: 4,
            h: 7,
            x: 0,
            y: 32,
            i: "6",
            minW: 1,
            minH: 1,
            moved: false,
            static: false
        }
    ],
    md: [
        {
            w: 5,
            h: 15,
            x: 0,
            y: 0,
            i: "1",
            minW: 1,
            minH: 1,
            moved: false,
            static: false
        },
        {
            w: 5,
            h: 5,
            x: 5,
            y: 0,
            i: "2",
            minW: 1,
            minH: 1,
            moved: false,
            static: false
        },
        {
            w: 5,
            h: 5,
            x: 0,
            y: 15,
            i: "3",
            minW: 1,
            minH: 1,
            moved: false,
            static: false
        },
        {
            w: 5,
            h: 3,
            x: 5,
            y: 5,
            i: "4",
            minW: 1,
            minH: 1,
            moved: false,
            static: false
        },
        {
            w: 5,
            h: 7,
            x: 5,
            y: 8,
            i: "5",
            minW: 1,
            minH: 1,
            moved: false,
            static: false
        },
        {
            w: 5,
            h: 5,
            x: 5,
            y: 15,
            i: "6",
            minW: 1,
            minH: 1,
            moved: false,
            static: false
        },
        {
            w: 5,
            h: 5,
            x: 0,
            y: 20,
            i: "7",
            minW: 1,
            minH: 1,
            moved: false,
            static: false
        }
    ]
};
/**
 * Grid to house widgets for drag and drop ability implemented using the
 * react-grid-layout library.
 */
let WidgetGrid = class WidgetGrid extends React.Component {
    constructor(props) {
        super(props);
        // @observable
        this.layouts = defaultLayouts;
        this.uploadModal = false;
        this.user = {};
        this.showClearAllConfirmation = false;
        this.shouldReloadMessages = false;
        this.promptProviderSignature = false;
        this.promptRenewalAlert = false;
        this.renewalAlertMessage = "";
        this.checkProviderSignature = () => {
            const { userProvider } = store_1.usersStore;
            if (userProvider.value && !userProvider.value.signature) {
                this.promptProviderSignature = true;
            }
        };
        this.onHandleCredentialUpload = () => {
            this.uploadType = "credential";
            this.uploadModal = true;
        };
        this.onHandleImageUpload = () => {
            this.uploadType = "image";
            this.uploadModal = true;
        };
        this.onHandleClickDeleteUpload = async (upload) => {
            await store_2.dashboardStore.deleteProviderAsset(upload);
            this.provider = store_2.dashboardStore.provider;
        };
        this.onHandleClickCancelUpload = () => {
            this.uploadModal = false;
        };
        /**
         * Saves layouts to local storage
         * @param layout The current layout of the grid and widgets
         * @param layouts An object of breakpoints -- lg, md, sm, xs, xxs -- storing layout for various breakpoints.
         */
        this.onLayoutChange = async (layout, layouts) => {
            if (this.user.id) {
                await store_2.dashboardStore.saveLayout(this.user.id, layouts);
            }
            this.layouts = layouts;
        };
        this.getProviderImage = () => {
            try {
                if (store_2.dashboardStore.provider.uploads.length > 0) {
                    const imageUpload = store_2.dashboardStore.provider.uploads.find((upload) => upload.informationType === "providerImage");
                    if (imageUpload) {
                        return imageUpload.filePath;
                    }
                    return "";
                }
                return "";
            }
            catch (error) {
                return "";
            }
        };
        this.providerWidget = () => {
            if (this.provider) {
                return (React.createElement(React.Fragment, null,
                    React.createElement("h4", { className: "widget__header" }, "Clinic Providers"),
                    React.createElement(provider_widget_1.ProviderWidget, { site: this.pharmacy, user: this.user, provider: this.provider, image: this.getProviderImage() })));
            }
            return null;
        };
        this.renderSignatureModal = () => {
            const { userProvider } = store_1.usersStore;
            const to = `/providers/${userProvider.value ? userProvider.value.id : ""}`;
            return (React.createElement(alert_modal_1.AlertModal, { width: 400, height: 200, title: "Provider Signature Alert", message: "No provider signature detected. Redirect to the edit form to add a signature.", onClick: () => router_1.RouteManager.transitionTo(to), onCancel: () => (this.promptProviderSignature = false) }));
        };
        this.renderRenewalModal = () => {
            const { userProvider } = store_1.usersStore;
            const to = `/providers/${userProvider.value ? userProvider.value.id : ""}`;
            return (React.createElement(alert_modal_1.AlertModal, { width: 400, height: 200, title: "Renewal Alert", message: this.renewalAlertMessage, onClick: () => router_1.RouteManager.transitionTo(to), onCancel: () => (this.promptRenewalAlert = false) }));
        };
        this.renderClearAllConfirmation = () => (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Confirm", cancelText: "Cancel", message: "Confirming will clear all alerts.", onCancel: () => (this.showClearAllConfirmation = false), onConfirm: this.handleClearAllAlerts, title: "Are you sure you want to proceed?" }));
        this.handleClearAllAlerts = async () => {
            const userId = store_1.usersStore.user.value.id;
            const siteId = store_1.usersStore.user.value.siteId;
            const options = {
                userId,
                siteId
            };
            await store_2.dashboardStore.clearAlerts(options);
            this.shouldReloadMessages = true;
            this.showClearAllConfirmation = false;
        };
        this.handleShowClearAllAlertsConfirmation = () => {
            this.showClearAllConfirmation = true;
        };
        this.handleSetShouldReloadMessagesToFalse = () => {
            this.shouldReloadMessages = false;
        };
        this.handleAssetsUpload = async (accepted) => {
            await store_2.dashboardStore.upload(accepted, String(this.provider.id), this.uploadType);
            router_1.RouteManager.transitionTo(`/dashboard`);
        };
    }
    componentWillMount() {
        // this.layouts = defaultLayouts;
    }
    /**
     * Fetch the layouts from local storage if applicable.
     */
    async componentDidMount() {
        await store_1.usersStore.loadUser();
        this.user = await store_1.usersStore.user.value;
        await store_2.dashboardStore.initializeLayouts(this.user.id, defaultLayouts);
        this.layouts =
            (await store_2.dashboardStore.getLayout(this.user.id)) || defaultLayouts;
        await store_2.dashboardStore.getProviderWidget(this.user.site.picProviderId);
        this.provider = store_2.dashboardStore.provider;
        this.pharmacy = store_1.usersStore.user.value.site || {};
        this.forceUpdate();
        if (store_2.dashboardStore.newLogin &&
            window.performance.navigation.type !== 1 &&
            document.referrer.includes("login")) {
            if (store_1.usersStore.userProvider.value) {
                this.checkProviderSignature();
                const today = moment().startOf("day");
                const deaExpired = today.isSameOrAfter(store_1.usersStore.userProvider.value.deaExp);
                const licenseExpired = today.isSameOrAfter(store_1.usersStore.userProvider.value.stateLicenseExp);
                const isExpired = today.isSameOrAfter(store_1.usersStore.userProvider.value.deaExp) &&
                    today.isSameOrAfter(store_1.usersStore.userProvider.value.stateLicenseExp);
                if (isExpired) {
                    // alert(
                    //   "RENEWAL ALERT: Your DEA and State License have expired. You will not be able to dispense any medications until they are updated."
                    // );
                    this.promptRenewalAlert = true;
                    this.renewalAlertMessage =
                        "Your DEA and State License have expired. You will not be able to dispense any medications until they are updated.";
                }
                else {
                    if (deaExpired) {
                        // alert(
                        //   "RENEWAL ALERT: Your DEA has expired. You will not be able to dispense any medications until it is updated."
                        // );
                        this.promptRenewalAlert = true;
                        this.renewalAlertMessage =
                            "Your DEA has expired. You will not be able to dispense any medications until it is updated.";
                    }
                    if (licenseExpired) {
                        // alert(
                        //   "RENEWAL ALERT: Your State License has expired. You will not be able to dispense any medications until it is updated."
                        // );
                        this.promptRenewalAlert = true;
                        this.renewalAlertMessage =
                            "Your State License has expired. You will not be able to dispense any medications until it is updated.";
                    }
                }
            }
            store_2.dashboardStore.newLogin = false;
        }
    }
    async componentWillUpdate() {
        this.provider = store_2.dashboardStore.provider;
    }
    static get defaultProps() {
        return {
            className: "layout",
            cols: { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 },
            rowHeight: 30
        };
    }
    /**
     * Reset layouts to initial hardcoded state.
     */
    async resetLayout() {
        this.layouts = defaultLayouts;
        await store_2.dashboardStore.saveLayout(this.user.id, defaultLayouts);
        window.location.reload();
    }
    *renderWidgets() {
        const keyIndex = 1;
        store_1.usersStore.permissions.ViewAlertsWidget
            ? yield (React.createElement("div", { key: "1" },
                React.createElement("h4", { className: "widget__header" }, "ALERTS & NOTIFICATIONS"),
                React.createElement(alert_widget_1.AlertWidget, { shouldReloadMessages: this.shouldReloadMessages, showClearAllAlertsConfirmation: this.handleShowClearAllAlertsConfirmation, setShouldReloadMessagesToFalse: this.handleSetShouldReloadMessagesToFalse })))
            : null;
        store_1.usersStore.permissions.ViewDispenseWidget
            ? yield (React.createElement("div", { key: "2" },
                React.createElement("h4", { className: "widget__header" }, "DISPENSE RATE (Previous 30 Days)"),
                React.createElement(dispense_widget_1.DispenseWidget, null)))
            : null;
        store_1.usersStore.permissions.ViewPadWidget
            ? yield (React.createElement("div", { key: "3" },
                React.createElement("h4", { className: "widget__header" }, "Signature Pads"),
                React.createElement(pad_widget_1.PadWidget, null)))
            : null;
        store_1.usersStore.permissions.ViewClaimsWidget
            ? yield (React.createElement("div", { key: "4" },
                React.createElement("h4", { className: "widget__header" },
                    "Today's Insurance Claims for",
                    " ",
                    store_1.usersStore.user.value.site.displayName),
                React.createElement(claim_widget_1.ClaimWidget, null)))
            : null;
        store_1.usersStore.permissions.ViewPharmacyWidget
            ? yield (React.createElement("div", { key: "5" },
                React.createElement("h4", { className: "widget__header" }, "Pharmacy Info"),
                React.createElement(pharmacy_widget_1.PharmacyWidget, null)))
            : null;
        store_1.usersStore.permissions.ViewProviderWidget
            ? yield (React.createElement("div", { key: "6" }, this.providerWidget()))
            : null;
        store_1.usersStore.permissions.ViewFinancialWidget
            ? yield (React.createElement("div", { key: "7" },
                React.createElement("h4", { className: "widget__header" }, "Financial Overview"),
                React.createElement(financial_widget_1.FinancialWidget, null)))
            : null;
        store_1.usersStore.permissions.ViewPaymentWidget
            ? yield (React.createElement("div", { key: "8" },
                React.createElement("h4", { className: "widget__header" }, "Outstanding Payments"),
                React.createElement(payment_widget_1.PaymentWidget, null)))
            : null;
        store_1.usersStore.permissions.ViewIntentWidget
            ? yield (React.createElement("div", { key: "9" },
                React.createElement("h4", { className: "widget__header" }, "Intent Claims"),
                React.createElement(intent_widget_1.IntentWidget, null)))
            : null;
        true
            ? yield (React.createElement("div", { key: "10" },
                React.createElement("h4", { className: "widget__header" }, "Backorder"),
                React.createElement(backorder_widget_1.BackorderWidget, null)))
            : null;
    }
    render() {
        return (React.createElement("div", { className: "grid-layout-container" },
            this.promptProviderSignature ? this.renderSignatureModal() : null,
            this.promptRenewalAlert ? this.renderRenewalModal() : null,
            React.createElement("div", { className: "reset-layout-btn" },
                React.createElement(button_1.MaterialButton, { flat: true, secondary: true, onClick: () => this.resetLayout() }, "Reset Layout")),
            React.createElement(ResponsiveReactGridLayout, { className: "layout", layouts: this.layouts, breakpoints: { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }, cols: { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }, rowHeight: 30, onLayoutChange: (layout, layouts) => this.onLayoutChange(layout, layouts) }, [...this.renderWidgets()]),
            this.uploadModal && (React.createElement(upload_modal_1.UploadModal, { onCancel: this.onHandleClickCancelUpload, message: `Please select files for ${this.provider.firstName} ${this.provider.lastName}, ${this.provider.title}.`, title: "Upload Documents", onDrop: this.handleAssetsUpload })),
            this.showClearAllConfirmation
                ? this.renderClearAllConfirmation()
                : null));
    }
};
__decorate([
    mobx_1.observable
], WidgetGrid.prototype, "uploadModal", void 0);
__decorate([
    mobx_1.observable
], WidgetGrid.prototype, "provider", void 0);
__decorate([
    mobx_1.observable
], WidgetGrid.prototype, "uploadType", void 0);
__decorate([
    mobx_1.observable
], WidgetGrid.prototype, "pharmacy", void 0);
__decorate([
    mobx_1.observable
], WidgetGrid.prototype, "user", void 0);
__decorate([
    mobx_1.observable
], WidgetGrid.prototype, "image", void 0);
__decorate([
    mobx_1.observable
], WidgetGrid.prototype, "showClearAllConfirmation", void 0);
__decorate([
    mobx_1.observable
], WidgetGrid.prototype, "shouldReloadMessages", void 0);
__decorate([
    mobx_1.observable
], WidgetGrid.prototype, "promptProviderSignature", void 0);
__decorate([
    mobx_1.observable
], WidgetGrid.prototype, "promptRenewalAlert", void 0);
__decorate([
    mobx_1.observable
], WidgetGrid.prototype, "renewalAlertMessage", void 0);
WidgetGrid = __decorate([
    mobx_react_1.observer
], WidgetGrid);
exports.WidgetGrid = WidgetGrid;
/**
 * Fetch the layouts from local storage.
 * @param key The string key to fetch the layouts from local storage.
 */
function getFromLocalStorage(key) {
    let localStorage = {};
    if (window.localStorage) {
        try {
            localStorage = JSON.parse(window.localStorage.getItem("rgl-8")) || {};
        }
        catch (e) {
            console.log(e);
        }
    }
    const layouts = localStorage[key];
    return layouts;
}
/**
 * Save layouts to local storage.
 * @param key The string key to store the layouts to local storage.
 * @param value The layouts to be stored in local storage.
 */
function saveToLocalStorage(key, value) {
    if (window.localStorage) {
        window.localStorage.setItem("rgl-8", JSON.stringify({
            [key]: value
        }));
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/dashboard/modules/widget-grid/widget-grid.tsx
// module id = 3287
// module chunks = 0